import {
  ControlledCheckbox,
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { languagesOptions } from '../constants/languages';
import { useFormContext } from 'react-hook-form';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { useTranslation } from 'react-i18next';

export const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  return (
    <>
      <MultiStepForm.Section title={t('tableTabs.TENANT_SETTINGS')}>
        <ControlledTextField
          control={control}
          name="tenant_name"
          label={t('tenantSettings.name')}
        />
        <ControlledCheckbox
          control={control}
          name="domain_redirect"
          label={t('tenantSettings.redirectToNewDomain')}
          disabled
        />
        <ControlledTextField
          control={control}
          name="tenant_loginbanner"
          label={t('tenantSettings.loginBanner')}
          multiline
        />
        <ControlledTextField
          disabled
          control={control}
          name="tenant_timezone"
          label={t('tenantSettings.timezone')}
        />
        <ControlledSelect
          control={control}
          name="tenant_language"
          label={t('tenantSettings.language')}
          options={languagesOptions}
        />
        <ControlledTextField
          control={control}
          name="tenant_s3bucketname"
          label={t('tenantSettings.s3bucketname')}
        />
        <ControlledTextField
          control={control}
          name="tenant_awsAccessKey"
          label={t('tenantSettings.awsAccessKey')}
        />
        <ControlledTextField
          control={control}
          name="tenant_awsSecretKey"
          label={t('tenantSettings.awsSecretKey')}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('tenantSettings.customerInformation')}>
        <ControlledTextField
          control={control}
          name="tenant_internal_sdb_group_number"
          label={t('tenantSettings.internalSDBGroupNumber')}
        />
        <ControlledTextField
          control={control}
          name="tenant_internal_sdb_group_name"
          label={t('tenantSettings.internalSDBGroupName')}
        />
      </MultiStepForm.Section>
    </>
  );
};
